module.exports = __webpack_public_path__ + "media/images/LED-icon-green-46c17df197ac3e133e294ed94b4d558b.svg";